export default __webpack_public_path__ + "static/media/growth_hacking.64818a0a.jpg";